import { ArbeitszeitReportFilters, ScheduleStatus, DeviationStatus } from '@myapp/contract'
import { toOptionalNumber, toOptionalString } from '../../../../shared/lib/optionalParsers'

export type { ScheduleStatus, DeviationStatus }

export interface ArbeitszeitReportFiltersForm {
  dateFrom: string
  dateTo: string
  technicianId: string
  tradeId: string
  scheduleStatus: ScheduleStatus[]
  deviationStatus: DeviationStatus[]
}

export const INITIAL_ARBEITSZEIT_REPORT_FILTERS: ArbeitszeitReportFiltersForm = {
  dateFrom: '',
  dateTo: '',
  technicianId: '',
  tradeId: '',
  scheduleStatus: [],
  deviationStatus: [],
}

export const mapArbeitszeitFiltersFormToApi = (
  f: ArbeitszeitReportFiltersForm,
  pages: { pageAuftraege: number; pageAuslastung: number; pageArbeitsorganisation: number },
): ArbeitszeitReportFilters => ({
  dateFrom: toOptionalString(f.dateFrom),
  dateTo: toOptionalString(f.dateTo),
  technicianId: toOptionalNumber(f.technicianId),
  tradeId: toOptionalNumber(f.tradeId),
  scheduleStatus: f.scheduleStatus.length > 0 ? f.scheduleStatus : undefined,
  deviationStatus: f.deviationStatus.length > 0 ? f.deviationStatus : undefined,
  pageAuftraege: pages.pageAuftraege,
  pageAuslastung: pages.pageAuslastung,
  pageArbeitsorganisation: pages.pageArbeitsorganisation,
})
